import axios from "axios";
import routes from "../../configs/api";
import getCouponAuthHeaders from "./couponAuthHeaders";

const deleteCoupon = (id) => {
  return new Promise((resolve, reject) => {
    let headers;

    try {
      headers = getCouponAuthHeaders();
    } catch (error) {
      reject(error);
      return;
    }

    axios
      .delete(`${routes.DELETE_COUPON}/${id}`, {
        headers,
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export default deleteCoupon;
